// Libraries
import React, {useEffect} from 'react';
import {Row, Form, Modal, Col} from 'antd';
import {useSelector} from "react-redux";

// Store
import {useAppDispatch} from '../../store/store';
import {getParams} from "../../store/redux/actions/orderActions";
import * as orderSelectors from "../../store/redux/selectors/orderSelectors";
import {reCreateGuide} from "../../store/redux/actions/shipmentActions";

// Types
import {ReCreateGuideType, ShipmentType} from "../../types/shipmentTypes";

// Components
import ButtonComponent from '../subComponents/ButtonComponent';
import FormItemComponent from '../subComponents/FormItemComponent';
import InputComponent from '../subComponents/InputComponent';
import SelectComponent from "../subComponents/SelectComponent";


type PropsType = {
  shipmentToReCreate?: ShipmentType;
  orderNumber: string;
  onToggleModal: (visible: boolean) => void;
};
const ReCreateGuideModal = (props: PropsType) => {
  const [form] = Form.useForm<ReCreateGuideType>();
  const dispatch = useAppDispatch();
  const { shipmentToReCreate, orderNumber, onToggleModal } = props;
  const { carriers } = useSelector(orderSelectors.orderParamsSelector);
  const showDimensionsForm = !shipmentToReCreate?.detailPackageDimensions || !shipmentToReCreate?.detailPackageText;

  useEffect(() => {
    dispatch(getParams());
  }, []);

  const handleSubmit = () => {
    const values = form.getFieldsValue();
    values.shipmentId = shipmentToReCreate!.shipmentId;

    dispatch(reCreateGuide(values, orderNumber));
    onToggleModal(false);
  }

  return (
    <Modal title={`Crear nuevamente el envío`}
           open={true} maskClosable={false} closable={false} keyboard={false} destroyOnClose={true}
           footer={[
             <ButtonComponent key={'cancel'} text={'Cerrar'}
                              className={'w-32 h-8 bg-white border border-grey-dkt-300 leading-4 text-grey-dkt-700 ' +
                                'hover:bg-grey-dkt-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-dkt-400'}
                              onClick={() => onToggleModal(false)} />,
             <ButtonComponent key={'submit'} text={'Crear'}
                              className={'w-32 h-8 text-white bg-blue-dkt-400 hover:bg-blue-dkt-500 focus:outline-none focus:ring-2 ' +
                                'focus:ring-offset-2 focus:ring-blue-dkt-300 after:content-none'}
                              onClick = {() => form.submit()}/>,
           ]}>
      <Form layout={"vertical"}
            form={form}
            onFinish={handleSubmit}>
        <Row className={'grid grid-cols-1 gap-x-2'}>
          <FormItemComponent name={'allianceId'}
                             label={'Alianza'}
                             required={true}
                             child={<SelectComponent list={carriers} />}
          />

          {showDimensionsForm &&
            <Col className={'grid grid-cols-2 gap-x-2'}>
              <p className={'col-span-2 mb-5'}>
                La siguiente información no está guardada. Por favor, complétala para continuar con el proceso:
              </p>

              <FormItemComponent name={['dimensions', 'height']}
                                 label={'Alto (cm)'}
                                 required={true}
                                 child={<InputComponent />}
              />

              <FormItemComponent name={['dimensions', 'width']}
                                 label={'Ancho (cm)'}
                                 required={true}
                                 child={<InputComponent />}
              />

              <FormItemComponent name={['dimensions', 'depth']}
                                 label={'Profundidad'}
                                 required={true}
                                 child={<InputComponent />}
              />

              <FormItemComponent name={['dimensions', 'weight']}
                                 label={'Peso'}
                                 required={true}
                                 child={<InputComponent />}
              />

              <FormItemComponent name={['dimensions', 'units']}
                                 label={'Unidades'}
                                 required={true}
                                 child={<InputComponent />}
              />

              <FormItemComponent name={'detail'}
                                 label={'Detalles'}
                                 required={true}
                                 className={'col-span-2'}
                                 child={<InputComponent type={'textarea'} />}
              />
            </Col>
          }
        </Row>
      </Form>
    </Modal>
  );
}

export default ReCreateGuideModal;